<div class="facilitator">
    <div class="editable_container">
        <div *ngIf="record['facilitators']">
            <div class="editable_field" style="max-width:calc(100% - 4em);"
                [ngStyle]="getFieldStyle()">
                <span *ngIf="record['facilitators']">
                    <span *ngFor="let facilitator of record.facilitators; let i = index" (click)="toggleExpand()" style="cursor: pointer;">
                        {{facilitator.fn.trim()}}<span *ngIf="i < record.facilitators.length-1; else theEnd">,</span><ng-template #theEnd>.</ng-template>
                    </span>
                    <i style="margin-left: 0.5rem; cursor: pointer;" class="faa"
                        [ngClass]="expandIconClass" aria-hidden="true" data-toggle="tooltip" [title]="expandButtonAlterText" [aria-label]="expandButtonAlterText"
                        (click)="toggleExpand()"></i>
                </span>

                <div [@detailExpand]="expanded ? 'expanded' : 'collapsed'" class="facilitator-detail">
                    <div class="facilitatorsdetail" *ngIf="record.facilitators">
                        <div *ngFor="let facilitator of record.facilitators; let i = index" style="padding-left: 1em;">
                            <div>
                                <span>{{ facilitator.jobTitle }} : {{facilitator.fn}} </span>
                                <span *ngIf="facilitator.orcid">&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a href="https://orcid.org/{{ author.orcid }}" target="blank">
                                    <img src="assets/images/orcid-logo.png" style="width: 20px;" alt="Facilitator's orcid">:
                                    {{ facilitator.orcid }}
                                    </a>
                                </span>                            
                            </div>
                            <div *ngFor="let aff of facilitator.affiliation" style="padding-left: 1em">
                                <i>
                                <div>{{aff.title}}</div>
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>